import { clearTimeoutRefreshToken, setTimeoutRefreshToken } from '@helpers/fetcher/session/expire';
import { useEffect } from 'react';

export default function useRefreshToken() {
  useEffect(() => {
    const setTimeoutRefreshTokenFn = () => {
      setTimeoutRefreshToken(60); // Refresh token when it will expire in <= 60 second
    };

    window.addEventListener('blur', clearTimeoutRefreshToken);
    window.addEventListener('focus', setTimeoutRefreshTokenFn);

    setTimeoutRefreshTokenFn();

    return () => {
      window.removeEventListener('blur', clearTimeoutRefreshToken);
      window.removeEventListener('focus', setTimeoutRefreshTokenFn);
    };
  }, []);
}
